import { render, staticRenderFns } from "./BankTransferPage.vue?vue&type=template&id=7a55f62d&scoped=true&"
import script from "./BankTransferPage.vue?vue&type=script&lang=js&"
export * from "./BankTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferPage.vue?vue&type=style&index=0&id=7a55f62d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55f62d",
  null
  
)

export default component.exports